export const ALL_LANGUAGES = [
  "ps-AF",
  "ar-EG",
  "sv-AX",
  "sq-AL",
  "ar-DZ",
  "en-AS",
  "ca-AD",
  "pt-AO",
  "en-AQ",
  "en-AI",
  "en-AG",
  "es-GQ",
  "es-AR",
  "hy-AM",
  "nl-AW",
  "az-AZ",
  "am-ET",
  "en-AU",
  "en-BS",
  "ar-BH",
  "bn-BD",
  "en-BB",
  "be-BY",
  "nl-BE",
  "en-BZ",
  "fr-BJ",
  "en-BM",
  "dz-BT",
  "es-BO",
  "bs-BA",
  "en-BW",
  "no-BV",
  "pt-BR",
  "en-IO",
  "ms-BN",
  "bg-BG",
  "fr-BF",
  "fr-BI",
  "es-CL",
  "zh-CN",
  "en-CK",
  "es-CR",
  "nl-CW",
  "da-DK",
  "fr-CD",
  "de-DE",
  "en-DM",
  "es-DO",
  "fr-DJ",
  "es-EC",
  "es-SV",
  "fr-CI",
  "ti-ER",
  "et-EE",
  "en-FK",
  "fo-FO",
  "en-SZ",
  "en-FJ",
  "fi-FI",
  "en-FM",
  "fr-FR",
  "fr-GF",
  "fr-PF",
  "fr-TF",
  "fr-MC",
  "fr-GA",
  "en-GM",
  "ka-GE",
  "en-GH",
  "en-GI",
  "en-GD",
  "el-GR",
  "kl-GL",
  "fr-GP",
  "en-GU",
  "es-GT",
  "en-GG",
  "fr-GN",
  "pt-GW",
  "en-GY",
  "fr-HT",
  "en-HM",
  "es-HN",
  "en-HK",
  "hi-IN",
  "id-ID",
  "en-IM",
  "ar-IQ",
  "fa-IR",
  "ga-IE",
  "is-IS",
  "he-IL",
  "it-IT",
  "en-JM",
  "ja-JP",
  "ar-YE",
  "en-JE",
  "ar-JO",
  "en-VG",
  "en-VI",
  "en-KY",
  "km-KH",
  "en-CM",
  "en-CA",
  "pt-CV",
  "nl-BQ",
  "ar-QA",
  "kk-KZ",
  "en-KE",
  "ky-KG",
  "en-KI",
  "en-UM",
  "en-CC",
  "es-CO",
  "ar-KM",
  "sq-XK",
  "hr-HR",
  "es-CU",
  "ar-KW",
  "lo-LA",
  "en-LS",
  "lv-LV",
  "ar-LB",
  "en-LR",
  "ar-LY",
  "de-LI",
  "lt-LT",
  "fr-LU",
  "zh-MO",
  "fr-MG",
  "dv-MV",
  "en-MW",
  "ms-MY",
  "fr-ML",
  "mt-MT",
  "ar-MA",
  "en-MH",
  "fr-MQ",
  "ar-MR",
  "en-MU",
  "fr-YT",
  "es-MX",
  "ro-MD",
  "mn-MN",
  "sr-ME",
  "en-MS",
  "pt-MZ",
  "my-MM",
  "en-NA",
  "en-NR",
  "ne-NP",
  "fr-NC",
  "en-NZ",
  "es-NI",
  "nl-NL",
  "fr-NE",
  "en-NG",
  "en-NU",
  "ko-KP",
  "en-MP",
  "mk-MK",
  "en-NF",
  "no-NO",
  "ar-OM",
  "de-AT",
  "pt-TL",
  "ur-PK",
  "ar-PS",
  "en-PW",
  "es-PA",
  "en-PG",
  "es-PY",
  "es-PE",
  "en-PH",
  "en-PN",
  "pl-PL",
  "pt-PT",
  "es-PR",
  "fr-CG",
  "fr-RE",
  "rw-RW",
  "ro-RO",
  "ru-RU",
  "en-MF",
  "en-SB",
  "en-ZM",
  "sm-WS",
  "it-SM",
  "fr-BL",
  "pt-ST",
  "ar-SA",
  "sv-SE",
  "de-CH",
  "fr-SN",
  "sr-RS",
  "fr-SC",
  "en-SL",
  "en-ZW",
  "en-SG",
  "nl-SX",
  "sk-SK",
  "sl-SI",
  "so-SO",
  "es-ES",
  "si-LK",
  "en-SH",
  "en-KN",
  "en-LC",
  "fr-PM",
  "en-VC",
  "af-ZA",
  "ar-SD",
  "en-GS",
  "ko-KR",
  "en-SS",
  "nl-SR",
  "no-SJ",
  "ar-SY",
  "tg-TJ",
  "zh-TW",
  "sw-TZ",
  "th-TH",
  "fr-TG",
  "en-TK",
  "en-TO",
  "en-TT",
  "fr-TD",
  "cs-CZ",
  "ar-TN",
  "tr-TR",
  "la-VA",
  "tk-TM",
  "en-TC",
  "en-TV",
  "en-UG",
  "uk-UA",
  "es-UY",
  "hu-HU",
  "uz-UZ",
  "bi-VU",
  "es-VE",
  "ar-AE",
  "en-US",
  "en-GB",
  "vi-VN",
  "fr-WF",
  "en-CX",
  "es-EH",
  "fr-CF",
  "el-CY",
];
